<template>
  <div class="tab-container">
    <div class="tabs-links">
      <div
        v-for="tab in tabs"
        :key="tab.name"
        class="tab-link"
        :class="{ 'is-active': tab.isActive }"
        @click="selectTab(tab)"
      >
        <span v-translate>{{ tab.name }}</span>
        <!--<CheckIcon v-if="tab.isActive" class="check-icon" />-->
      </div>
    </div>

    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import CheckIcon from '@/components/CheckIcon'
export default {
  name: 'TabContainer',
  props: ['selectedTabName'],
  components: {
    CheckIcon,
  },
  data() {
    return { tabs: [] }
  },
  created() {
    this.tabs = this.$children
    if (this.selectedTabName) {
      this.selectTab({ name: this.selectedTabName })
    }
  },
  // NIP 9/22/20  Was getting an infinite rendering error locally, because <CheckIcon /> was getting pulled
  //              into this.$children, then set as this.tabs. I started to filter this.$children to remove
  //              the CheckIcon component by using its ref - and then suddenly the problem resolved.
  //
  //              Leaving this in temporarily in case the problem reoccurs.
  // mounted() {
  //   console.log(this.$children[0].$refs)
  // },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name == selectedTab.name
      })
      this.$emit('changed-tab', selectedTab.name)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';
.tab-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0;
}
.tabs-links {
  display: flex;
  flex-direction: row;
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 1rem;
  width: 100%;
  border-bottom: 1px solid #dfdfe0;
}
.tab-link {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: 1rem 2rem;
  text-transform: uppercase;

  &:first-of-type {
    margin-left: 1rem;
  }
}
.tabs-details {
  padding: 2rem 1.5rem;
}
.is-active {
  border-bottom: 2px solid black;
}
a:hover {
  cursor: pointer;
}
.check-icon {
  margin-left: 0.2rem;
}
</style>
